import type { RouteRecordRaw } from 'vue-router';

// /producten
// /leveranciers
// /gevaren
// /gevaren/gevaarcategorieen
// /analyseregels
// /nodes/{globalid}
// /companies

export default [
    {
        path: '/',
        name: 'welcome',
        component: () => import('../pages/Welcome.vue'),
        meta: {
            layout: 'landing',
        },
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../pages/Dashboard.vue'),
        meta: {
            layout: 'app',
            requiresAuth: true,
        },
    },
] satisfies RouteRecordRaw[];
